<template>
  <div class="question-container">
    <spinner v-show="showAnswerLoader" />
    <div v-if="question && currentLevel" class="questions-block-wrap" :class="[!showLoader ? 'show-content' : '']">
      <div
        class="total-score"
        :class="validAnswer !== null ? [validAnswer === false ? 'invalid' : 'valid'] : ''"
      >
        {{ totalScore }}
        <span>stig</span>
      </div>
      <timer
        ref="timer"
        :timerHeight=116
        :timerWidth=116
        :question="question"
        :initTimer="timerVal"
        :hasTimerStart="hasTimerStart"
        :questionKey="question.key"
        :validAnswer="validAnswer"
        @hasStartCbk="hasStarted"
        @clickAnswer="proceed"
      />
      <p class="scale-count">Spurning&nbsp;{{ questionIndex + 1 }}/{{ currentLevel.questions_per_level }}</p>
      <status-bar :answerSheet="Object.values(userGameInfo[currentLevel.name])" />
      <div class="answer" :class="[selected && !validAnswer ? 'invalid' : '']">
        <span v-show="!!selected && validAnswer !== null">{{ validAnswer ? 'Rétt svar' : 'Rangt svar' }}</span>
      </div>
      <div class="question-block-inner">
        <p class="question">{{question.question}}</p>
        <div class="radio" id="options">
          <div class="update-wrap" v-for="(option,index) in question.options" :key="index.key" :class="[selected==option ? 'selected' : '', selected==option && validAnswer !== null && validAnswer ? 'valid' : '', selected==option && validAnswer !== null && !validAnswer ? 'invalid' : '']">
            <label class="radio-label container" :for="index" :class="[selected==option ? 'selected' : '']">{{option}}
              <input :id="index" :value="option" name="answer" type="radio" v-model="selected" v-on:change="clickAnswer(selected)" :disabled="selected || !timerVal">
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <img class="logo" :src="gameContent.logo" alt="" height="86" width="89" />
  </div>
</template>
<script>
import API from '@/shared/api'
import { primeGreetings } from '@/shared/dataModels'
import StatusBar from './StatusBar.vue'
import Spinner from './Spinner.vue'
export default {
  components: { StatusBar, Spinner },
  name: 'QuizComponent',
  props: {
    'question': {
      type: Object,
      default () {
        return {}
      }
    },
    'currentLevel': {
      type: Object,
      default () {
        return {}
      }
    },
    'questionIndex': {
      type: Number,
      default: 0
    },
    'questionData': {
      type: Object,
      default () {
        return {}
      }
    },
    'userGameInfo': {
      type: Object,
      default () {
        return {}
      }
    },
    'totalScore': {
      type: Number,
      default: 0,
    },
    showQuestions: false,
  },
  data () {
    return {
      dataReady: false,
      validAnswer: null,
      showLoader: true,
      selected: null,
      primeGreetings: primeGreetings,      
      timerVal: this.currentLevel.seconds_per_question,
      hasTimerStart: true,
      gameContent: {},
      showAnswerLoader: false,
    }
  },
  created () {
    this.gameContent = this.$data.globalData.gameContent
    this.userGameInfo[this.currentLevel.name][this.questionIndex.toString()] = 'current'
  },
  methods: {
    clickAnswer (answer) {
      this.hasTimerStart = false
      this.selected = answer
    },
    proceed (timeout = false) {
      if(this.selected !=null || timeout) {
        this.showAnswerLoader = true
        API.meInstance.post('/question/validate/', { 'question_key': this.question.key, 'answer': this.selected }).then((res) => {          
          let postData = {}
          if (res.data) {
            this.validAnswer = res.data.data.answer
            this.$emit('validAnswer', this.validAnswer)
            postData['isValid'] = res.data.data.answer
            postData['givenAnswer'] = this.selected
            postData['consumedTime'] = res.data.consumed_time
            setTimeout(() => {
              this.$emit('answerValidate', postData)
            }, 3000)
            this.showAnswerLoader = false
            setTimeout(() => {
              this.selected = null
              this.validAnswer = null
            }, 3000)
          }
        })
      }
      else {
        this.$notify({
          customClass: 'error-msg',
          message: this.$createElement('i', { style: 'color: #f7653a' }, 'Vinsamlegast veldu hvaða valkost sem er.')
        })
        var elmnt = document.getElementById("options")
        elmnt.scrollIntoView();
      }
    },
    hasStarted () {
      this.showLoader = false
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
	0% {
		opacity: 0;
	}
  50% {
    opacity: 0.5;
  }
	100% {
		opacity: 1;
	}
}
.timer-wrapper,
.scale-count,
.status-page,
.total-score,
.question {
  opacity: 0;
  animation: fadeIn 200ms forwards 500ms;
}
.question-container {
  position: relative;
  padding-bottom: 20px;
  .spinner-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.13);
  }
}
.logo {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.5s forwards;
}
.question-block-inner {
  .question {
    opacity: 0;
    animation:  fadeIn 100ms forwards 300ms;
  }
  #options {
    opacity: 0;
    animation: fadeIn 300ms forwards 800ms;
  }
  &.prime {
    padding-top: 5rem;
    &.el-loading-parent--relative {
      opacity: 0 !important;
      animation-duration: .5s !important;
      animation-fill-mode: both !important;
      animation-name: fadingOffEffect !important;
    }
  }
  @media screen and (max-width: 767px){
    #options {
      margin-bottom: 70px;
    }
  }
}
.question-count, .status-bar-inner {
  display: inline-block;
  vertical-align: middle;
}
.prime-logo {
  text-align: center;
  padding-top: 2rem;
  svg {
    width: 100px;
    height: 100px;
  }
}
.button-container {
  text-align: center;
}
.button {
  &.btn-svara {
    // margin-right: 1.6rem;
    padding: 1.5rem 16rem;
    width: 100%;
    @media screen and (min-width: 767px){
      width: 50%;
      // margin-right: 20px !important;
    }
    @media screen and (min-width: 1200px){
      width: unset;
      margin-right: unset;
    }
    &.secondary {
      background: #fff;
      color: #011627;
      border: 2px solid #fcbd00;
    }
  }
}
.medal-details-wrap {
  text-align: center;
  padding-top: 7rem;
  padding-bottom: 10.5rem;
  h3 {
    font-size: 35px;
    line-height: 42px;
    font-weight: 600;
    padding-bottom: 30px;
    @media screen and (max-width: 767px){
      text-shadow: 2px 2px 5px #0000007d;
      color: #fff;
    }
  }
  p {
    font-weight: normal;
    font-size: 28px;
    line-height: 140%;
    max-width: 438px;
    padding-bottom: 40px;
    margin: auto;
    @media screen and (min-width: 767px){
      max-width: 600px;
    }
  }
  .prime-text {
    background: #ffffffba;
    padding: 10px;
    border-radius: 4px;
    span {
      display: block;
      padding-bottom: 10px;
    }
  }
}
.prime-level-wrap {
  background: url(/static/images/regluvordur-bg.jpg);
  background-size: cover;
  background-position: bottom;
  background-repeat: no-repeat;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &.remove-flex {
    display: block;
  }
}
.questions-block-wrap {
  display: flex;
  flex-direction: column;
  opacity: 0;
  &.show-content {
    animation: fadeIn 0.5s forwards;
  }
  .total-score {
    top: 16px;
    max-width: 165px;
    padding: 10px 58px;
    font-weight: 400;
    font-size: 20px;
    color: #011627;
    background: #ffffff;
    border-radius: 10px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-weight: 500;
    font-size: 32px;
    line-height: 1;
    z-index: -1;
    box-shadow: 0px 0px 50px 0px #0000001A;
    margin-bottom: 50px;
    &.valid {
      color: #2EC3B5;
    }
    &.invalid {
      color: #FF6A6A;
    }
    span {
      font-weight: 400;
      font-size: 14px;
      line-height: 18.48px;
    }
  }
  .timer-wrapper {
    order: 1;
    margin-bottom: 40px;
  }
  .scale-count {
    order: 3;
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 21.12px;
    margin-bottom: 16px;
  }
  .question-block-inner{
    order: 5;
  }
  .status-page {
    order: 4;
    position: relative;
    left: auto;
    top: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 25px;
    /deep/.status-bar-inner {
      height: 20px;
      width: 20px;
      margin: 0 calc(5px / 2);
      border: none;
    }
  }
  .answer {
    order: 2;
    color: #2DADA1;
    font-weight: 400;
    line-height: 132%;
    margin-bottom: 18px;
    font-size: 18px;
    min-height: 24px;
    text-align: center;
    &.invalid {
      color: #FF6A6A;
    }
  }
  &.show-question {
    .question-block-inner {
      opacity: 1;
      background: transparent;
    }
    .question-index.prime{
      margin-top: 0;
    }
  }
  .question-index{
    font-size: 14px;
    font-weight: 300;
    text-align: left;
  }
  &.hide-question {
    height: initial !important;
    transition: all .3s ease-in-out;
    .question-index.prime{
      opacity: 0;
    }
    .question-block-inner{
      opacity: 0;
    }
  }
}
  //update-code
  .radio {
    padding-top: 0.5rem;
    &:focus, &:active {
      border: initial;
    }
  }
  .checkbox, .radio {
    position: relative;
    display: flex;
    margin: 20px 0;
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-start;
    @media screen and (min-width: 1200px) {
      flex-direction: row;
    }
  }
  .update-wrap {
    border: 1px solid #CCD0D4;
    background: #FFFFFF;
    border-radius: 10px;
    text-align: left;
    margin-bottom: 29px;
    width: 338px;
    display: inline-block;
    vertical-align: top;
    min-height: 55px;
    transition: all 0.2s linear;
    &:hover {
      transform: scale(1.01);
      box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
    }
    label {
      padding: 1.2rem 1.5rem;
      padding-left: 5rem;
      height: 100%;
      min-height: 55px;
      line-height: 132%;
      display: flex;
      align-items: center;
    }
    .checkmark {
      margin-left: 1rem;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .question-block-inner {
    text-align: center;
  }
  .question {
    background: #FFFFFF;
    box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    font-size: 16px;
    line-height: 150%;
    color: #011627;
    padding: 16px 80px;
    max-width: 700px;
    margin: 0 auto;
    margin-bottom: 42px;
  }
  .button {
    padding: 1.5rem 15rem;
    &.spila {
      // margin-left: 1rem;
      border-radius: 10px;
      &.prime-btn {
        width: initial;
        padding: 1.5rem 12rem !important;
      }
    }
  }

  .last-level {
    padding-top: 0;
    padding-bottom: 2.5rem;
  }

  .point-circle {
  &.correct {
    .animate-svg-circle{
      color: #85DB7E;
      stroke: #85DB7E;
    }
    svg {
      border: 7px solid #85DB7E;
      border-radius: 50%;
      width: 110px;
      height: 110px;
    }
  }
  &.wrong {
    .animate-svg-circle{
      color: #EF856B;
      stroke: #EF856B;
    }
    svg {
      border: 7px solid #EF856B;
      border-radius: 50%;
    }
  }
}

@media (max-width: 768px) {
  .logo {
    display: none;
  }
  .prime-level-wrap {
    background-size: cover;
    .questions-block-wrap {
      height: initial;
      padding-top: 2rem;
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
      &.show-question {
        padding-top: 23rem;
        display: block;
      }
      &.hide-question {
        padding-top: 17rem;
      }
      &.show-prime {
        padding-top: 0;
      }
    }
  }
  .medal-details-wrap {
    &.last-level {
      padding-top: 0;
    }
  }
  .home-page {
    // transform: translateY(65px);
    // height: 110%;
    @media screen and (min-width: 767px){
      height: 100%;
    }
    @media screen and (min-width: 1200px){
      height: 100%;
    }
    .questions-block-wrap  {
      overflow-y: hidden;
      height: 100%;
      overflow-x: hidden;
    }
    .button-container {
      // box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
    }
  }
  .questions-block-wrap {
    .update-wrap {
      width: 100%;
      margin-bottom: 10px;
    }
    .timer-wrapper {
      margin-bottom: 28px;
    }
    .scale-count {
      order: 2
    }
    .status-page {
      order: 3;
      margin-bottom: 16px;
      /deep/.status-bar-inner {
        height: 14px;
        width: 14px;
        margin: 0 calc(6px / 2);
      }
    }
    .answer {
      order: 4;
      font-size: 16px;
      margin-bottom: 14px;
    }

    .question-block-inner {
      .question {
        margin-bottom: 20px;
      }
    }

  }
  .total-score {
    border-radius: 10px;
    padding: 10px 30px;
    left: auto;
    top: 16px;
    width: fit-content;
    font-size: 20px;
    flex-direction: row;
    align-items: baseline;
    z-index: 1;
    margin-bottom: 28px;
    span {
      margin-left: 3px;
    }
  }
}
.game-lifes-popup-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 100%;
  background: rgba(0,0,0,0.7);
  z-index: 9;
  .game-lifes-popup {
    max-width: 475px;
    position: relative;
    transform: translate(-50%, -50%);
    top: 50%;
    left: calc(50% - 10px);
    margin: 10px;
    border-radius: 10px;
    background: #fff;
    padding: 35px;
    box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);
    text-align: center;
    button {
      margin-right: 0;
      padding-left: 0;
      padding-right: 0;
      margin-right: 0 !important;
      width: 50%;
      @media screen and (min-width: 1200px) {
        width: 50%;
      }
    }
  }
}
</style>
<style lang="scss">
  .alert-message-outer {
    padding-bottom: 1rem;
    position: fixed;
    bottom: -33px;
    left: 50%;
    padding-top: 1rem;
    // transform: translateX(180px);
    width: 100%;
    background: transparent;
    // background: #F8F8F8;
    transform: translate(-50%, -50%);
    .el-alert--warning {
      background: #FEF2CC;
      color: #011627;
      border-radius: 13px;
      padding: 10px 20px;
      padding-bottom: 12px;
      .el-icon-warning:before {
        color: #FFBA02;
      }
      .el-alert__closebtn {
        color: #011627;
        top: 16px;
        font-size: 16px;
        font-weight: 600;
      }
    }
    .error {
      &.el-alert--warning {
        background: #FFE1E1;
      }
      .el-icon-warning:before {
        color: #FF6A6A;
      }
    }
    .el-alert__icon {
      padding-top: 4px;
      font-size: 14px;
    }
    .el-alert__title {
      font-size: 14px;
    }
  }
  @media (max-width: 768px) {
    .question-block-inner {
      &.prime {
        padding-top: 4rem !important;
      }
    }
    .error-msg {
      &.el-notification {
        padding-top: 5px !important;
      }
    }
    .top-space {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
</style>
